class c {
  constructor(s) {
    this.value = s;
  }
}
export {
  c as EnumType
};
//# sourceMappingURL=EnumType.mjs.map
